import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";
import { type Annotation } from "@features/custom-annotations";

import { AnnotationEdit } from "./annotation-edit";
import { AnnotationMetadata } from "./annotation-metadata";

interface AnnotationCardProps {
  annotation: Annotation;
  editAnnotation: (annotation: Annotation) => void;
}

export const AnnotationCard = ({
  annotation,
  editAnnotation,
}: AnnotationCardProps) => (
  <div className="space-y-1.5">
    <AnnotationMetadata annotation={annotation} />
    <div
      className={clsx(
        "bg-interstellar-3 rounded group/edit text-sm flex items-center justify-between",
        "px-4 py-2",
      )}
    >
      <div className="flex items-center gap-2">
        {annotation.isUsedForTraining && (
          <GenericTooltip
            noInfoCircle
            content="This calendar event was used for model training"
          >
            <i className="fa-regular fa-flask-gear text-venus" />
          </GenericTooltip>
        )}
        <div className="break-all">{annotation.description}</div>
      </div>
      <AnnotationEdit annotation={annotation} editAnnotation={editAnnotation} />
    </div>
  </div>
);
